exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* \n.pagination {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n.page-item {\n  margin: 0 2px;\n}\n.page-link {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 8px 16px;\n  font-size: 16px;\n  text-decoration: none;\n}\n.page-link i {\n  font-size: 20px;\n}\n@media (max-width: 600px) {\n  .page-link {\n    padding: 8px 12px;\n    font-size: 14px;\n  }\n  .page-link i {\n    font-size: 18px;\n  }\n} */\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/app/clearance-item/pagination/paginator.component.css
// module id = 470
// module chunks = 1